import { Col, Row } from 'react-bootstrap';
import '@syncfusion/ej2-react-inplace-editor/styles/inplace-editor/material.css';
import 'components/ProviderData/IpaAdministration/organisms/IpaAdministration.css';

type IpaAdministrationDetailViewDetailInfoProps = {
    ipa: Record<string, any>;
    contractInfoForm: any;
    errors: any;
};

function IpaAdministrationDetailViewDetailInfo(props: IpaAdministrationDetailViewDetailInfoProps) {
    return (
        props?.contractInfoForm && (
            <div>
                <Row>
                    <Col md={11}>
                        <div className={`e-float-input e-input-group e-input-group-margin`}>
                            <input
                                type='text'
                                {...props?.contractInfoForm('vendorName', {
                                    maxLength: {
                                        value: 100,
                                        message: 'Vendor Name must be maximum 100 characters length',
                                    },
                                })}
                            />
                            <span className='e-float-line'></span>
                            <label className='e-float-text boldCss'>Vendor Name</label>
                        </div>
                        {props?.errors?.vendorName && <p className='error-form'>{props.errors.vendorName.message}</p>}
                    </Col>
                    <Col md={6}>
                        <div className={`e-float-input e-input-group e-input-group-margin`}>
                            <input
                                type='text'
                                {...props?.contractInfoForm('taxId', {
                                    maxLength: {
                                        value: 60,
                                        message: 'Tax ID must be maximum 60 characters length',
                                    },
                                })}
                            />
                            <span className='e-float-line'></span>
                            <label className='e-float-text boldCss'>Tax Id</label>
                        </div>
                        {props?.errors?.taxId && <span className='error-form'>{props.errors.taxId.message}</span>}
                    </Col>
                    <Col md={5}>
                        <div className={`e-float-input e-input-group e-input-group-margin`}>
                            <input
                                type='text'
                                {...props?.contractInfoForm('npi', {
                                    maxLength: {
                                        value: 60,
                                        message: 'NPI must be maximum 60 characters length',
                                    },
                                })}
                            />
                            <span className='e-float-line'></span>
                            <label className='e-float-text boldCss'>NPI</label>
                        </div>
                        {props?.errors?.npi && <span className='error-form'>{props.errors.npi.message}</span>}
                    </Col>
                </Row>
                <Row>
                    <Col md={11}>
                        <div className={`e-float-input e-input-group e-input-group-margin`}>
                            <input
                                type='text'
                                {...props?.contractInfoForm('addr', {
                                    maxLength: {
                                        value: 80,
                                        message: 'Address must be maximum 80 characters length',
                                    },
                                })}
                            />
                            <span className='e-float-line'></span>
                            <label className='e-float-text boldCss'>Address</label>
                        </div>
                        {props?.errors?.addr && <p className='error-form'>{props.errors.addr.message}</p>}
                    </Col>
                </Row>
                <Row>
                    <Col md={11}>
                        <div className={`e-float-input e-input-group e-input-group-margin`}>
                            <input
                                type='text'
                                {...props?.contractInfoForm('addr2', {
                                    maxLength: {
                                        value: 80,
                                        message: 'This field must be maximum 80 characters length',
                                    },
                                })}
                            />
                            <span className='e-float-line'></span>
                            <label className='e-float-text boldCss'>Suite/Bldg/No</label>
                        </div>
                        {props?.errors?.addr2 && <p className='error-form'>{props.errors.addr2.message}</p>}
                    </Col>
                </Row>
                <Row>
                    <Col md={11}>
                        <div className={`e-float-input e-input-group e-input-group-margin`}>
                            <input
                                type='text'
                                {...props?.contractInfoForm('city', {
                                    maxLength: {
                                        value: 80,
                                        message: 'City must be maximum 80 characters length',
                                    },
                                })}
                            />
                            <span className='e-float-line'></span>
                            <label className='e-float-text boldCss'>City</label>
                        </div>
                        {props?.errors?.city && <p className='error-form'>{props.errors.city.message}</p>}
                    </Col>
                </Row>
                <Row>
                    <Col md={6}>
                        <div className={`e-float-input e-input-group e-input-group-margin`}>
                            <input
                                type='text'
                                {...props?.contractInfoForm('state', {
                                    maxLength: {
                                        value: 2,
                                        message: 'State must be 2 characters length',
                                    },
                                    minLength: {
                                        value: 2,
                                        message: 'State must be 2 characters length',
                                    },
                                })}
                            />
                            <span className='e-float-line'></span>
                            <label className='e-float-text boldCss'>State</label>
                        </div>
                        {props?.errors?.state && <p className='error-form'>{props.errors.state.message}</p>}
                    </Col>
                    <Col md={5}>
                        <div className={`e-float-input e-input-group e-input-group-margin`}>
                            <input
                                type='text'
                                {...props?.contractInfoForm('zip', {
                                    maxLength: {
                                        value: 20,
                                        message: 'Zip Code must be maximum 20 characters length',
                                    },
                                })}
                            />
                            <span className='e-float-line'></span>
                            <label className='e-float-text boldCss'>Zip Code</label>
                        </div>
                        {props?.errors?.zip && <p className='error-form'>{props.errors.zip.message}</p>}
                    </Col>
                </Row>
                <Row>
                    <Col md={6}>
                        <div className={`e-float-input e-input-group e-input-group-margin`}>
                            <input
                                type='text'
                                {...props?.contractInfoForm('vendorPhoneNumber', {
                                    pattern: {
                                        value: /^\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}$/,
                                        message: 'Phone number is not valid',
                                    },
                                })}
                            />
                            <span className='e-float-line'></span>
                            <label className='e-float-text boldCss'>Phone</label>
                        </div>
                        {props?.errors?.vendorPhoneNumber && <p className='error-form'>{props.errors.vendorPhoneNumber.message}</p>}
                    </Col>
                    <Col md={5}>
                        <div className={`e-float-input e-input-group e-input-group-margin`}>
                            <input
                                type='text'
                                {...props?.contractInfoForm('vendorFaxNumber', {
                                    pattern: {
                                        value: /^\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}$/,
                                        message: 'Fax number is not valid',
                                    },
                                })}
                            />
                            <span className='e-float-line'></span>
                            <label className='e-float-text boldCss'>Fax</label>
                        </div>
                        {props?.errors?.vendorFaxNumber && <p className='error-form'>{props.errors.vendorFaxNumber.message}</p>}
                    </Col>
                </Row>
                <Row>
                    <Col md={11}>
                        <div className={`e-float-input e-input-group e-input-group-margin`}>
                            <input
                                type='text'
                                {...props?.contractInfoForm('emailAddress', {
                                    pattern: {
                                        value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                        message: 'Please enter a valid email',
                                    },
                                })}
                            />
                            <span className='e-float-line'></span>
                            <label className='e-float-text boldCss'>Email</label>
                        </div>
                        {props?.errors?.emailAddress && <p className='error-form'>{props.errors.emailAddress.message}</p>}
                    </Col>
                </Row>
            </div>
        )
    );
}

export default IpaAdministrationDetailViewDetailInfo;
